export default __webpack_public_path__ + "static/media/edit.97f18457.svg";